<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {PromotionType} from "../../../../../common/components/ob1/models/Price";

export default defineComponent({
    name: "AdditionalPrice",
    props: {
        title: {
            type: String,
            required: true,
        },
        initialPrice: {
            type: String,
            required: true,
        },
        promotionPrice: {
            type: String,
            required: true,
        },
        promotionDuration: {
            type: Number,
            required: true,
        },
        promotionType: {
            type: Object as PropType<PromotionType>,
            required: true,
        },
    }
})
</script>

<template>
    <div class="bg-greige p-1 mb-1">
        <p class="small m-0 p-0">
            <strong>{{ title }}</strong>
        </p>
        <p class="small m-0 p-0">
            <span v-html="promotionPrice + '/mois'" />
            <span v-if="promotionType === 'PROMO_DURATION'">
                pendant {{ promotionDuration }}&nbsp;mois puis
                <strong v-html="initialPrice + '/mois'" />
            </span>
            <span v-if="promotionType === 'END_OF_PROMO'">
                puis
                <strong v-html="initialPrice + '/mois'" />
                à la fin de vos promotions
            </span>
        </p>
    </div>
</template>
